import { render, staticRenderFns } from "./InfoBanner.vue?vue&type=template&id=e8a55d2a"
import script from "./InfoBanner.vue?vue&type=script&lang=ts"
export * from "./InfoBanner.vue?vue&type=script&lang=ts"
import style0 from "./InfoBanner.vue?vue&type=style&index=0&id=e8a55d2a&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports